export default "__VITE_ASSET__BwbFe6J2__"